// extracted by mini-css-extract-plugin
export var label = "_ik-2";
export var slideContainer = "_ik-0";
export var slider = "_ik-1";